import styled from "styled-components";

import { colors, radii } from "shared/ui";

export const Header = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
`;

export const TariffTitle = styled.span`
    font-size: 1.25rem;
    font-weight: 600;
    color: ${colors.textPrimary};
`;

export const StatusBadge = styled.span<{ $status: "active" | "overdue" | "expired" }>`
    padding: 3px 10px;
    border-radius: ${radii.small};
    font-size: 13px;
    color: ${({ $status }) => {
        if ($status === "active") return colors.primary;
        if ($status === "overdue") return colors.textPrimary;
        return colors.danger;
    }};
    background: ${({ $status }) => {
        if ($status === "active") return colors.infoBg;
        if ($status === "overdue") return colors.warningBg;
        return colors.dangerBg;
    }};
`;

export const Actions = styled.div`
    margin-top: 18px;
`;
